module.exports = __webpack_public_path__ + "static/img/lianxiwomen_title.0c31a90.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/lianxiwomen_title.png
// module id = sH7x
// module chunks = 0